<template>
  <div class="iframe-panel">
    <iframe
      class="iframe-panel__content"
      :src="iFrameObject.iframe"
      frameborder="0"
      ref="iframePanel"
      v-show="loaded"
      scrolling="auto"
      @load="loaded = true"
    />
    <LoadingIcon v-if="!loaded"/>
  </div>
</template>

<script>
import LoadingIcon from '@/components/global/loading/LoadingIcon.vue';

export default {
  components: {
    LoadingIcon
  },
  props: {
    iFrameObject: Object
  },
  data: () => ({
    loaded: false
  }),
  watch: {
    iFrameObject(){
      this.loaded = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.iframe-panel {
  width: 100%;
  height: 100%;
  
  &__content {
    width: 100%;
    height: 100%;
    background: white;
  }
}
</style>
